import React from "react";
import PhoneInput from "react-phone-input-2";

export default function CustomPhoneInput({
  label,
  touched,
  error,
  countryCode,
  phoneNumber,
  setFieldValue,
  disabled,
  placeholder,
}) {
  return (
    <div className="common-modal-field position-relative">
      <label>{label}</label>
      <PhoneInput
        enableSearch={true}
        country="ca"
        disabled={disabled}
        placeholder={placeholder || "Enter your phone number"}
        value={`${countryCode}${phoneNumber}`}
        onChange={(value, data) => {
          const rawPhone = value
            .replace(/[^0-9]+/g, "")
            .slice(data?.dialCode?.length);
          setFieldValue("phoneNumber", rawPhone);
          setFieldValue("countryCode", data.dialCode);
        }}
      />

      {touched && error && (
        <p style={{ color: "red", marginBottom: 0 }}>{error}</p>
      )}
    </div>
  );
}
